import React from "react";
import PropTypes from "prop-types";
import Body from "./Body";

/** @type {React.FunctionComponent<BodyStrongProps>} */
const BodyStrong = ({ raw, children }) => (
  <Body raw={raw} type="strong">
    {children}
  </Body>
);

/** @typedef {PropTypes.InferProps<typeof propTypes>} BodyStrongProps */
const propTypes = {
  children: PropTypes.node.isRequired,
  raw: PropTypes.bool,
};
Body.propTypes = propTypes;

export default BodyStrong;
